import client from '../client'

export const getAuctionInfoKey = `${process.env.NEXT_PUBLIC_AUCTION_DOMAIN}/api/Auctions/GetAuctionInformation`

export async function getAuctionInfo({ auctionId }) {
  const params = new URLSearchParams({ auctionId })

  return client(`${getAuctionInfoKey}?${params}`)
}
